import ResourceService from './resource.service'

class WaterSourceService extends ResourceService {
  static get resource() {
    return 'water-source'
  }
}

export default WaterSourceService
